<div class="complete-card">
<div class="form-container">
  <div class="header">
    <h3>Complete Inspection</h3>
    <mat-icon class="expand-icon">expand_less</mat-icon>
  </div>

  <div class="dynamic-form-layout">
    <ng-container *ngFor="let item of layoutItems">
        <div *ngIf="item.type === 'field'" [ngClass]="getFieldWidthClass(item.entity)">
          <ng-container [ngTemplateOutlet]="fieldRenderer" [ngTemplateOutletContext]="{ field: item.entity }"></ng-container>
        </div>

        <!-- Matrix Tables (Full width) -->
        <div *ngIf="item.type === 'table'" class="field-full-width matrix-table-container">
          <table class="matrix-layout-table">
            <tbody>
              <tr *ngFor="let row of item.rows">
                <td *ngFor="let cell of row.cells" [attr.colspan]="cell.colspan" [attr.rowspan]="cell.rowSpan">
                  <span *ngIf="cell.type === 'text'" class="matrix-static-text" [innerHTML]="cell.staticText"></span>
                  <div *ngIf="cell.type === 'entity' && cell.entity" class="matrix-field-wrapper">
                    <ng-container [ngTemplateOutlet]="fieldRenderer" [ngTemplateOutletContext]="{ field: cell.entity }"></ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </ng-container>
    </div>

    <div class="actions">
      <button mat-stroked-button class="cancel-btn" (click)="onCancel()">CANCEL</button>
      <button mat-flat-button color="primary" class="confirm-btn" [disabled]="!isFormValid" (click)="onSubmit()">CONFIRM</button>
    </div>
  </div>
</div>

<!-- Dynamic Control Engine -->
<ng-template #fieldRenderer let-field="field">
  <ng-container [ngSwitch]="field.dataEntityTypeCode">

    <ng-container *ngSwitchCase="'date'">
      <mat-form-field appearance="outline" class="full-width hide-subscript">
        <mat-label>{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></mat-label>
        <input matInput [matDatepicker]="dynamicPicker" placeholder="MM/DD/YYYY" [(ngModel)]="formValues[field.$id]" [disabled]="field.isReadOnly">
        <mat-datepicker-toggle matIconSuffix [for]="dynamicPicker"></mat-datepicker-toggle>
        <mat-datepicker #dynamicPicker></mat-datepicker>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="'free-form-text'">
      <!-- Safely toggle hide-subscript based on custom TS validation logic -->
      <mat-form-field appearance="outline" class="full-width" [class.hide-subscript]="!isFieldInvalid(field)">
        <mat-label>{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></mat-label>
        
        <input matInput [ngModel]="formValues[field.$id]" (ngModelChange)="onTextModelChange(field, $event)" [readonly]="field.isReadOnly" [disabled]="field.isReadOnly" *ngIf="!field.isMultiline" [pattern]="getPattern(field)" [attr.maxlength]="getMaxLength(field)">
        
        <textarea matInput [ngModel]="formValues[field.$id]" (ngModelChange)="onTextModelChange(field, $event)" [readonly]="field.isReadOnly" [disabled]="field.isReadOnly" rows="1" style="resize: none;" *ngIf="field.isMultiline" [pattern]="getPattern(field)" [attr.maxlength]="getMaxLength(field)"></textarea>
        
        <mat-error *ngIf="isFieldInvalid(field)">
           {{ getErrorMessage(field) }}
        </mat-error>
      </mat-form-field>
    </ng-container>

    <ng-container *ngSwitchCase="'list-data'">
      <div class="radio-group-wrapper">
        <label class="group-label">{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></label>
        <div class="radio-override-container">
          <wm-common-radio 
            [data]="listDataMap[field.$id]" 
            (valueChange)="onRadioChange(field.$id, $event)">
          </wm-common-radio>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'rich-text'">
      <div class="rich-text-wrapper" [innerHTML]="field.html"></div>
    </ng-container>

    <!-- Shared Signature Component Integration -->
    <ng-container *ngSwitchCase="'signature'">
      <div class="signature-block-container">
        <label class="group-label">{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></label>

        <div class="custom-inspection-sig-wrapper" #sigWrapper>
          <wm-signature-field
            #sigField
            [ngModel]="formValues[field.$id]"
            (valueChange)="onSignatureChange(field.$id, $event)">
          </wm-signature-field>
        </div>

        <button type="button" mat-flat-button class="clear-sig-btn" (click)="clearSignature(field.$id, sigField)">Clear</button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="field.dataEntityTypeCode === 'inspection-document' ? field.dataEntityTypeCode : 'document'">
      <div class="document-wrapper">
        <label class="group-label">{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></label>
        <input type="file" #fileInput hidden multiple (change)="onFileSelected($event, field)" />
        <button mat-flat-button color="primary" class="upload-btn" (click)="fileInput.click()">SELECT FILES</button>
        <p class="text-muted" *ngIf="field.validDocumentTypes">Valid Document Types: {{ field.validDocumentTypes }}</p>
        <div class="upload-spinner" *ngIf="uploadingMap[field.$id]">Uploading files...</div>
        <div class="uploaded-files-list" *ngIf="documentDataMap[field.$id]?.length > 0">
          <div class="uploaded-file-item" *ngFor="let doc of documentDataMap[field.$id]; let i = index">
            <mat-icon class="file-icon">insert_drive_file</mat-icon>
            <a class="file-name" [href]="doc.path" target="_blank" rel="noopener noreferrer">{{ doc.metaData?.originalName || doc.name }}</a>
            <mat-icon class="remove-icon" (click)="removeDocument(field.$id, i)">close</mat-icon>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <mat-form-field appearance="outline" class="full-width" [class.hide-subscript]="!isFieldInvalid(field)">
        <mat-label *ngIf="field.label">{{ field.label }} <span *ngIf="field.isRequired" class="req">*</span></mat-label>
        
        <input matInput [ngModel]="formValues[field.$id]" (ngModelChange)="onTextModelChange(field, $event)" [readonly]="field.isReadOnly" [disabled]="field.isReadOnly" *ngIf="!field.isMultiline" [pattern]="getPattern(field)" [attr.maxlength]="getMaxLength(field)">
        
        <textarea matInput [ngModel]="formValues[field.$id]" (ngModelChange)="onTextModelChange(field, $event)" [readonly]="field.isReadOnly" [disabled]="field.isReadOnly" rows="1" style="resize: none;" *ngIf="field.isMultiline" [pattern]="getPattern(field)" [attr.maxlength]="getMaxLength(field)"></textarea>

        <mat-error *ngIf="isFieldInvalid(field)">
           {{ getErrorMessage(field) }}
        </mat-error>
      </mat-form-field>
    </ng-container>

  </ng-container>
</ng-template>